"use strict";
// @ts-ignore
new Splide('.shop-brand-splide', {
    perPage: 6,
    perMove: 1,
    type: 'loop',
    gap: "0px",
    padding: {
        left: "0%",
        right: "0%"
    },
    pagination: false,
    arrows: false,
    autoScroll: {
        speed: 1,
    },
    breakpoints: {
        1600: {
            perPage: 4,
        },
        1199: {
            perPage: 3,
        },
        480: {
            perPage: 2,
        },
    },
    // @ts-ignore
}).mount(window.splide.Extensions);
